// Read SENSEA-THEME.md before editing. Rules are enforced by CI.
// sensea reserve card: the device count (- / + buttons and the field). Shows the price and Reserve links for the
// current count, and pre-selects it from ?devices=n (set by the Plans page buttons). Without this script the card
// stays on 1 device and still works.
function init(root) {
  const input = root.querySelector('.sensea-reserve__count');
  if (!input || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const max = Number(input.max) || 1;
  const less = root.querySelector('[data-step="-1"]');
  const more = root.querySelector('[data-step="1"]');
  const clamp = (n) => Math.min(max, Math.max(1, Math.round(Number(n) || 1)));

  function show(n) {
    input.value = String(n);
    for (const el of root.querySelectorAll('[data-plan]')) el.hidden = el.dataset.plan !== String(n);
    if (less) less.disabled = n <= 1;
    if (more) more.disabled = n >= max;
  }

  less?.addEventListener('click', () => show(clamp(Number(input.value) - 1)));
  more?.addEventListener('click', () => show(clamp(Number(input.value) + 1)));
  input.addEventListener('change', () => show(clamp(input.value)));
  input.addEventListener('input', () => {
    if (input.value !== '') show(clamp(input.value));
  });

  const wanted = new URLSearchParams(window.location.search).get('devices');
  show(clamp(wanted && /^\d+$/.test(wanted) ? wanted : input.value));
}

document.querySelectorAll('.sensea-reserve').forEach(init);
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.sensea-reserve').forEach(init));
